<template>
  <widget-container :widget="widget">
    <time-range-picker
      v-model="range"
      :disabled="!hideButtons"
      @change="update"
      @close="() => this.$emit('close')"
    />
    <v-card-actions v-if="!hideButtons">
      <v-spacer />
      <v-btn text small color="primary" @click="() => $emit('edit')">{{
        $t("common.edit")
      }}</v-btn>
      <v-btn text small color="error" @click="() => $emit('remove')">{{
        $t("common.delete")
      }}</v-btn>
    </v-card-actions>
    <v-card-actions v-else>
      <v-spacer />
      <v-btn text small color="primary" @click="() => $emit('close')">{{
        $t("common.close")
      }}</v-btn>
    </v-card-actions>
  </widget-container>
</template>

<script>
import { mapState } from "vuex";
import CsharpEnum from "@/_helpers/CsharpEnum";
import WidgetContainer from "./WidgetContainer.vue";
import widgetMixin from "@/_helpers/widgetMixin";
import TimeRangePicker from "@/components/common/TimeRangePicker.vue";
import { cloneDeep } from "lodash-es";

export default {
  name: "MasterTimePicker",

  mixins: [widgetMixin],
  components: { WidgetContainer, TimeRangePicker },

  props: {
    value: {
      default: undefined,
    },

    hideButtons: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      range: {
        start: undefined,
        end: undefined,
      },
    };
  },

  computed: {
    ...mapState("templateDashboard", ["globalWidgets", "globalValues"]),

    widget: {
      get() {
        return this.value;
      },

      set(val) {
        this.$emit("input", val);
      },
    },
  },

  methods: {
    update(selectedValue) {
      if (selectedValue == "start" || selectedValue == undefined) {
        let meta = this.widget.meta.find(
          (x) => x.key == this.metaKeys.GLOBAL_TIMERANGE_START
        );
        if (meta != undefined) meta.value = this.range.start;

        if (this.globalValues?.globalTimeRange?.start != this.range.start)
          this.$emit("update", {
            metaKey: this.metaKeys.GLOBAL_TIMERANGE_START,
            value: this.range.start,
          });
      }

      if (selectedValue == "end" || selectedValue == undefined) {
        let meta = this.widget.meta.find(
          (x) => x.key == this.metaKeys.GLOBAL_TIMERANGE_END
        );
        if (meta != undefined) meta.value = this.range.end;

        if (this.globalValues?.globalTimeRange?.end != this.range.end)
          this.$emit("update", {
            metaKey: this.metaKeys.GLOBAL_TIMERANGE_END,
            value: this.range.end,
          });
      }
    },

    async setup() {
      this.widget = this.value;

      this.range.start = cloneDeep(this.globalValues?.globalTimeRange?.start);
      this.range.end = cloneDeep(this.globalValues?.globalTimeRange?.end);
      if (this.range.start != undefined && this.range.end != undefined)
        this.update();

      let meta = this.widget.meta.find(
        (x) => x.key == this.metaKeys.GLOBAL_TIMERANGE_START
      );
      if (meta == undefined) {
        this.addMeta(this.metaKeys.GLOBAL_TIMERANGE_START, "-24h");
        this.range.start = "-24h";
      }

      meta = this.widget.meta.find(
        (x) => x.key == this.metaKeys.GLOBAL_TIMERANGE_END
      );
      if (meta == undefined) {
        this.addMeta(this.metaKeys.GLOBAL_TIMERANGE_END, "Now");
        this.range.end = "Now";
      }

      if (!this.hasTitle)
        this.widget.title =
          this.globalWidgets.find(
            (x) => x.widgetType == CsharpEnum.ModuleType.MASTERTIMEPICKER
          )?.title ?? "Dashboard Time Selector";
    },
  },

  async created() {
    await this.setup();
  },

  watch: {
    globalValues: {
      async handler(val) {
        if (val.globalTimeRange?.start != this.range.start) {
          this.range.start = val.globalTimeRange?.start;
        }
        if (val.globalTimeRange?.end != this.range.end) {
          this.range.end = val.globalTimeRange?.end;
        }
      },
      deep: true,
    },
  },
};
</script>
